import React from "react";
import ForgotPinLayer from "../components/ForgotPinLayer";

const ForgotPinPage = () => {
    return (
        <>
            <ForgotPinLayer />
        </>
    );
};

export default ForgotPinPage;
